import { useEffect, useState, useRef } from 'react'
import { FieldRenderProps } from 'react-final-form'
import useAdminpoly, { Lookup } from '../../playground/hooks/useAdminpoly'
import Dropdown from '../../control/Dropdown'

type DistrictInputProps = FieldRenderProps<any, HTMLElement> & {
    provinceID: number | string
    districtID: number | string
}

const DistrictInput: React.FC<DistrictInputProps> = ({ input, meta, provinceID, districtID, ...rest }) => {
    const { callServiceAdminpoly } = useAdminpoly()
    const [list, setList] = useState<Lookup[]>([])

    const distID = useRef<number | string>()
    useEffect(() => {
        if (!distID.current) distID.current = districtID
        else if (districtID !== distID.current) {
            distID.current = districtID
            input.onChange(null)
        }
    }, [provinceID, districtID])

    useEffect(() => {
        const fetch = async () => {
            if (districtID) {
                const { result } = await callServiceAdminpoly(provinceID, districtID)
                setList(result?.data)
            } else {
                setList([])
            }
        }
        fetch()
    }, [districtID])

    return (
        <Dropdown
            {...input}
            {...rest}
            meta={meta}
            options={list?.map((item) => ({
                value: item.id,
                label: item.name.th,
            }))}
            helperText={meta.error}
        />
    )
}

export default DistrictInput
